import {
  Directive,
  HostBinding,
  Inject,
  Input,

  OnDestroy, OnInit
} from '@angular/core';
import { AccordionDirective } from './accordion.directive';


@Directive({
  selector: '[appAccordionLink]',
  standalone: true
})
export class AccordionLinkDirective implements OnInit, OnDestroy {
  @Input() public group: unknown;

  @HostBinding('class.selected')
  @Input()
  public get selected(): boolean {
    return this._selected;
  }

  public set selected(value: boolean) {
    this._selected = value;
    if (value) {
      this.nav.closeOtherLinks(this);
    }
  }

  private _selected: boolean = false;
  private nav: AccordionDirective;

  public constructor(@Inject(AccordionDirective) nav: AccordionDirective) {
    this.nav = nav;
  }

  public ngOnInit(): void {
    this.nav.addLink(this);
  }

  public ngOnDestroy(): void {
    //this.nav.removeGroup(this);
  }

  public toggle(): void {
    this.selected = !this.selected;
  }
}
